import { create } from "zustand"
import { persist } from "zustand/middleware"
import localStorageNames from "data/localStorageNames"

export const useClientState = create(persist((set, get) => ({
    client: {}, 
    updateClient: (newClients) => {
        set({ client: newClients })
    }, 
    getClient: () => {
        return get().client
    }
}),
    {
        name: localStorageNames.CLIENT_AMPLIFY
    }
))